var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.img)?_c('div',{staticClass:"md__border border-radius bg-color-write m-4 box-shadow p-4"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('img',{attrs:{"src":_vm.img,"width":_vm.width,"alt":_vm.alt}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }